export class ValidationModel {
    public isValid: boolean;
    public error: string;
}


// WEBPACK FOOTER //
// ./src/app/core/models/validation.model.ts